export default __webpack_public_path__ + "static/media/inline2.e9a61f8c.png";